import { generateRule } from './generate'

export const utilityScopePrefix = 'yk-u-scope-'

function escapeClassName(value: string) {
	return value.replace(/([^a-zA-Z0-9_-])/g, '\\$1')
}

function hashString(value: string) {
	let hash = 2166136261

	for (const char of value) {
		hash ^= char.charCodeAt(0)
		hash = Math.imul(hash, 16777619)
	}

	return (hash >>> 0).toString(36)
}

export function isUtilityScopeClass(token: string) {
	return token.startsWith(utilityScopePrefix)
}

export function stripUtilityScopeClasses(tokens: string[]) {
	return tokens.filter((token) => !isUtilityScopeClass(token))
}

function dedupeInOrder(tokens: string[]) {
	const seen = new Set<string>()

	return tokens.filter((token) => {
		if (seen.has(token)) {
			return false
		}

		seen.add(token)
		return true
	})
}

export function getUtilityScope(tokens: string[]) {
	const utilityClasses = dedupeInOrder(
		stripUtilityScopeClasses(tokens).filter(
			(token) => generateRule(token) != null
		)
	)

	if (utilityClasses.length < 2) {
		return null
	}

	return {
		scopeClass: `${utilityScopePrefix}${hashString(utilityClasses.join(' '))}`,
		utilityClasses
	}
}

function buildScopedRule({
	scopeClass,
	utilityClass
}: {
	scopeClass: string
	utilityClass: string
}) {
	const rule = generateRule(utilityClass)
	if (rule == null) return null

	const scopedSelector = `.${scopeClass}.${escapeClassName(utilityClass)}`
	const responsiveMatch = rule.match(/^(@media [^{]+\{)\.[^{]+\{([^}]*)\}\}$/)

	if (responsiveMatch) {
		return `${responsiveMatch[1]}${scopedSelector}{${responsiveMatch[2]}}}`
	}

	const baseMatch = rule.match(/^\.[^{]+\{([^}]*)\}$/)
	if (baseMatch == null) return null

	return `${scopedSelector}{${baseMatch[1]}}`
}

export function buildScopedRules({
	scopeClass,
	utilityClasses
}: {
	scopeClass: string
	utilityClasses: string[]
}) {
	return utilityClasses
		.map((utilityClass) =>
			buildScopedRule({
				scopeClass,
				utilityClass
			})
		)
		.filter(Boolean)
		.join('')
}
